module.exports = "<div class=\"loading-mask\"></div>"


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/components/logout/logout.html
// module id = ../../../../../src/app/components/logout/logout.html
// module chunks = 1